import { __rest } from "tslib";
import React from 'react';
import Icon from '@vtblife/uikit-icons';
import Content from './content';
var InputIcon = function InputIcon(_a) {
  var _a$placement = _a.placement,
    placement = _a$placement === void 0 ? 'end' : _a$placement,
    onClick = _a.onClick,
    pointer = _a.pointer,
    dataTest = _a.dataTest,
    icon = __rest(_a, ["placement", "onClick", "pointer", "dataTest"]);
  return React.createElement(Content, {
    placement: placement,
    onClick: onClick,
    pointer: pointer,
    dataTest: dataTest
  }, React.createElement(Icon, Object.assign({}, icon)));
};
export default InputIcon;